import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { withSpacing } from '../../utils';
import { SpacingProps } from '../box';
import { skeletonAnimation } from '../../style/animations';

interface SkeletonProps extends SpacingProps {
  children?: React.ReactNode;
  className?: string;
  active?: boolean;
  backgroundColor?: string;
}

const Skeleton = styled(({ children, className, active }: SkeletonProps) => (
  <div className={classNames('box-skeleton', { active }, className)}>{children}</div>
))<SkeletonProps>`
  &.box-skeleton {
    ${withSpacing}

    &.active {
      line-height: 1;

      & > *:only-child {
        border: none !important;
        background-color: transparent !important;
        ${props => skeletonAnimation(props.backgroundColor)}
      }
    }
  }
`;

export default Skeleton;
